import {Part, PartType} from '../../models/Part';

export function calculateDurationMs(part: Part): number {
    switch (part.type) {
        case PartType.Distance:
            return part.distance_meters * (135 / 500) * 1000; //2:15 split
        case PartType.Duration:
            return part.duration_milliseconds;
        case PartType.Repetitions:
            return part.repetitions * 1000 * 3; //3 seconds per repetition
        case PartType.Rest:
            return part.rest_milliseconds;
        case PartType.OffErg:
            return part.duration_milliseconds;
    }
}
